export const CREATE_TEXT_ONLY = "CREATE_TEXT_ONLY";
export const UPDATE_TEXT_ONLY = "UPDATE_TEXT_ONLY";
export const DELETE_TEXT_ONLY = "DELETE_TEXT_ONLY";
